var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13 20.17a2.3 2.3 0 0 0 .1-3.41 2.35 2.35 0 0 0-3.41.1c-.62.7-1.07 2.45-1.34 3.5l-.1.38L2 22.01l1.27-.4c.02 0 .04 0 .07-.02.95-.24 2.92-.74 3.79-1.42Zm8.95-1.71a9.2 9.2 0 0 0 .96-3.78A12.8 12.8 0 0 0 22 4.48 2.48 2.48 0 0 0 19.5 2 12.79 12.79 0 0 0 9.3 6.95c-1.31.05-2.6.38-3.77.97a6.3 6.3 0 0 0-3.36 5.64v.82h4.54a2.9 2.9 0 0 1 2.9 2.9v4.53h.82a6.3 6.3 0 0 0 5.64-3.35Zm.86-9.47a1.94 1.94 0 1 0-3.87 0 1.94 1.94 0 0 0 3.87 0Z",
    fill: "#673ab7"
  })));
};

export default SvgRocket;